import { createFileRoute } from '@tanstack/react-router';

import { SubmissionsPage } from '@/features/submissions/components/admin/SubmissionsPage';

export const Route = createFileRoute('/admin/submissions')({
  component: SubmissionsPage,
});
